import React, { useMemo } from 'react';
import { ReorderRuleContext, ReorderRuleContextProps, reorderRuleSlice } from '../context/ReorderRuleContext';
import { ReorderRule } from '../types/reorderRule';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface ReorderRuleProviderProps {
  children: React.ReactNode;
}

export default function reorderRuleProvider({ children }: ReorderRuleProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.reorderRules.items);
  const loading = useAppSelector(state => state.reorderRules.loading);

  const { reorderRules, groupedReorderRules } = useMemo(() => {
    const reorderRules = new Map();
    const groupedReorderRules = new Map();
    for (const item of items) {
      const rule = new ReorderRule(item);
      reorderRules.set(rule.id, rule);
      const group = groupedReorderRules.get(rule.groupId) || [];
      groupedReorderRules.set(rule.groupId, [...group, rule]);
    }

    return { reorderRules, groupedReorderRules };
  }, [items]);

  const reorderRuleContext: ReorderRuleContextProps = {
    reorderRules,
    groupedReorderRules,
    reorderRulesLoading: loading,
    setReorderRules: (reorderRules: Map<string, ReorderRule>) =>
      dispatch(reorderRuleSlice.actions.setAll([...reorderRules.values()])),
  };

  return <ReorderRuleContext.Provider value={reorderRuleContext}>{children}</ReorderRuleContext.Provider>;
}
